import styled from 'styled-components'
import theme from 'theme_'

export const TemplatesMobileBlockKebabItemWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  gap: ${theme.spacing.xs};
`
